import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Action, NgxsOnInit, State, StateContext } from '@ngxs/store';
import { updateEntities } from '../utils';
import { PointOfInterest } from '../../core/models';
import { dispatchRequest } from '../dispatch-request';
import {
  DeletePoiAction, DeletePoiSuccessAction, DeletePoiFailAction,
  LoadPoiAction, LoadPoiSuccessAction, LoadPoiFailAction,
  SavePoiAction, SavePoiSuccessAction, SavePoiFailAction,
} from './poi.actions';
import { defaultRequestState, IRequestsNestedState } from '../interfaces/requests.interface';

export interface PoiStateModel {
  entities: { [key: number]: PointOfInterest };
  ids: number[];
  loadPoiPostRequestState: IRequestsNestedState;
  savePoiPostRequestState: IRequestsNestedState;
  deletePoiPostRequestState: IRequestsNestedState;
}

@State<PoiStateModel>({
  name: 'poi',
  defaults: {
    entities: {},
    ids: [],
    loadPoiPostRequestState: { ...defaultRequestState },
    savePoiPostRequestState: { ...defaultRequestState },
    deletePoiPostRequestState: { ...defaultRequestState },
  },
})
@Injectable()
export class PoiState implements NgxsOnInit {

  constructor(
    private httpClient: HttpClient,
  ) {}

  ngxsOnInit(ctx: StateContext<PoiStateModel>) {}

  @Action(LoadPoiAction)
  loadPoi(
    ctx: StateContext<PoiStateModel>,
    action: LoadPoiAction,
  ) {
    const request = this.httpClient.get('GetPointsOfInterest');

    return dispatchRequest(
      request,
      ctx,
      LoadPoiSuccessAction,
      LoadPoiFailAction,
      'loadPoiPostRequestState',
    );
  }

  @Action(LoadPoiSuccessAction)
  loadPoiSuccess(
    ctx: StateContext<PoiStateModel>,
    action: LoadPoiSuccessAction,
  ) {
    const stateUpdate = updateEntities(action.payload, PointOfInterest);
    ctx.patchState({
      entities: {
        ...ctx.getState().entities,
        ...stateUpdate.entities,
      },
      ids: [
        ...ctx.getState().ids,
        ...stateUpdate.ids,
      ],
    });
  }

  @Action(SavePoiAction)
  savePoi(
    ctx: StateContext<PoiStateModel>,
    action: SavePoiAction,
  ) {
    const request = this.httpClient.post(`SavePOI`, action.payload);

    return dispatchRequest(
      request,
      ctx,
      SavePoiSuccessAction,
      SavePoiFailAction,
      'savePoiPostRequestState',
    );
  }

  @Action(SavePoiSuccessAction)
  savePoiSuccess(
    ctx: StateContext<PoiStateModel>,
    action: SavePoiSuccessAction,
  ) {
    const poi = new PointOfInterest(action.payload);
    ctx.patchState({
      entities: {
        ...ctx.getState().entities,
        [poi.id]: poi,
      },
      ids: [
        ...ctx.getState().ids,
        poi.id,
      ],
    });
  }

  @Action(DeletePoiAction)
  deletePoi(
    ctx: StateContext<PoiStateModel>,
    action: DeletePoiAction,
  ) {
    const poiId: number = action.payload;
    const request = this.httpClient.post(`DeletePOI/?targetId=${poiId}`, poiId);

    return dispatchRequest(
      request,
      ctx,
      DeletePoiSuccessAction,
      DeletePoiFailAction,
      'deletePoiPostRequestState',
    );
  }

  @Action(DeletePoiSuccessAction)
  deletePoiSuccess(
    ctx: StateContext<PoiStateModel>,
    action: DeletePoiSuccessAction,
  ) {
    const poiId: number = action.payload;
    ctx.patchState({
      ids: ctx.getState().ids.filter(id => id !== poiId),
    });
  }
}
